import http from './index'

const verifyVoucher = async (voucher_code) => {
    return await http.get('/voucher/query/' + voucher_code)
}

export { verifyVoucher }
